/**
 * ナビゲーション
 */
export default {
  gnav: null,
  trigger: null,
  mq: null,
  isVisible: false,
  _onChangeMq: null,
  _onClickTrigger: null,
  _onClickGnav: null,
  _onClickParentNavMenu: null,

  init({ gnavSelector, triggerSelector, largeMediaQuery, currentBar }) {
    this.gnav = document.querySelector(gnavSelector);
    this.trigger = document.querySelector(triggerSelector);
    this.mq = window.matchMedia(largeMediaQuery);

    if (!this.gnav) return;

    this.currentBar = this.gnav.querySelector(currentBar);
    this.initCurrentBar();

    this.parentNavItems = this.gnav.querySelectorAll('[aria-expanded]');
    this.initHierarchicalNavItems();

    this.bindChangeMq();
    this.onChangeMq(this.mq);
    this.bindClickGnav();

    if (this.trigger) {
      this.bindClickTrigger();
    }
  },

  /**
   * 階層を持つナビゲーションメニューの初期設定
   *
   * @returns {void}
   */
  initHierarchicalNavItems() {
    if (!this.parentNavItems) return;

    Object.values(this.parentNavItems).forEach((parent) => {
      const label = parent.innerText;
      const children = parent.nextElementSibling;
      const menuId = parent.getAttribute('data-menu-id');

      if (!children || !menuId) return true;

      const childrenId = `sub-menu-of-${menuId}`;

      const submenuWrapper = document.createElement('div');
      submenuWrapper.id = childrenId;
      submenuWrapper.className = 'sub-menu-wrap';
      submenuWrapper.setAttribute('aria-labelledby', `${label}のサブメニュー`);
      submenuWrapper.appendChild(children);

      parent.setAttribute('aria-controls', childrenId);
      parent.after(submenuWrapper);

      this.bindClickParentNavMenu(parent);
    });
  },

  /**
   * @param {HTMLElement} trigger
   * @returns {void}
   */
  bindClickParentNavMenu(trigger) {
    if (this._onClickParentNavMenu) return;

    this._onClickParentNavMenu = (e) => {
      e.preventDefault();

      const ariaExpanded = e.currentTarget.getAttribute('aria-expanded');
      const toExpanded = ariaExpanded !== 'true';

      if (toExpanded) {
        this.showCurrentBar(e.currentTarget);
      } else {
        this.hideCurrentBar();
      }
      e.currentTarget.setAttribute('aria-expanded', toExpanded);

      const eventName =
        ariaExpanded !== 'true' ? 'show:submenu' : 'hide:submenu';

      this.gnav.dispatchEvent(
        new CustomEvent(eventName, { detail: { mq: this.mq } })
      );
    };

    trigger.addEventListener('click', this._onClickParentNavMenu, false);
  },

  initCurrentBar() {
    const firstNavItem = this.gnav.querySelector('.menu-item');
    if (!firstNavItem || !this.currentBar) return;

    const rect = firstNavItem.getBoundingClientRect();
    if (!rect) return;

    this.currentBar.style.left = `${rect.left}px`;
  },

  /**
   * @param {HTMLElement} triggerNavItem
   * @returns {void}
   */
  showCurrentBar(triggerNavItem) {
    if (!triggerNavItem) return;

    const rect = triggerNavItem.getBoundingClientRect();
    if (!rect) return;

    this.currentBar.style.left = `${rect.left}px`;
    this.currentBar.classList.add('is-visible');
    this.currentBar.style.width = `${rect.width}px`;
  },
  hideCurrentBar() {
    this.currentBar.classList.remove('is-visible');
  },

  onChangeMq(mq) {
    if (mq.matches) {
      this.show();
    } else {
      this.hide();
      this.hideCurrentBar();
      this.closeNavItems();
    }
  },

  bindChangeMq() {
    if (this._onChangeMq) return;

    this._onChangeMq = (e) => {
      this.onChangeMq(e);
    };

    if (this.mq.addEventListener) {
      // modern browser
      this.mq.addEventListener('change', this._onChangeMq, false);
    } else {
      // legacy browser (for IE)
      this.mq.addListener(this._onChangeMq);
    }
  },

  bindClickTrigger() {
    if (this._onClickTrigger) return;

    this._onClickTrigger = (e) => {
      this.toggle();
    };

    this.trigger.addEventListener('click', this._onClickTrigger, false);
  },

  isMobileView() {
    return !this.mq.matches;
  },

  bindClickGnav() {
    if (this._onClickGnav) return;

    this._onClickGnav = (e) => {
      const isClose = e.target.classList.contains('js-close-gnav');
      if (isClose && this.isMobileView()) {
        this.hide();
      }
    };

    this.gnav.addEventListener('click', this._onClickGnav, false);
  },

  show() {
    this.isVisible = true;
    this.gnav.setAttribute('data-expanded', false);
    this.trigger.setAttribute('aria-expanded', true);
    this.trigger.setAttribute('aria-label', '閉じる');

    this.gnav.dispatchEvent(
      new CustomEvent('show', { detail: { mq: this.mq } })
    );
  },

  hide() {
    this.isVisible = false;
    this.gnav.setAttribute('data-expanded', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-label', '開く');

    this.gnav.dispatchEvent(
      new CustomEvent('hide', { detail: { mq: this.mq } })
    );
  },

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  },

  closeNavItems() {
    Object.values(this.parentNavItems).forEach((parent) => {
      parent.setAttribute('aria-expanded', false);
    });
  },
};
